"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

function PayoutMethodsFactory(_ref) {
  var code = _ref.code,
      disabled = _ref.disabled;

  switch (code) {
    case 'WMR':
      return /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
        type: 'comment',
        "data-locator": "payout.note"
      }, "\u0420\u0430\u0437\u043E\u0432\u044B\u0439 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0432\u044B\u0432\u043E\u0434 \u043D\u0430\xA0WebMoney: 15\xA0000\xA0\u0440\u0443\u0431\u043B\u0435\u0439, \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0432\u044B\u0432\u043E\u0434\u043E\u0432 \u0432\xA0\u0441\u0443\u0442\u043A\u0438: 10. \u0421\u0443\u043C\u043C\u0430 \u0432\u044B\u0432\u043E\u0434\u0430 \u0431\u0443\u0434\u0435\u0442 \u0440\u0430\u0437\u0431\u0438\u0442\u0430 \u043D\u0430\xA0\u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438.");

    case 'WMZ':
      return /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
        type: 'comment',
        "data-locator": "payout.note"
      }, "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0432\u044B\u0432\u043E\u0434\u0430 \u2014 0.01$.\xA0\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0439 \u0441\u0443\u043C\u043C\u044B \u0432\u044B\u0432\u043E\u0434\u0430 \u043D\u0435\u0442.");

    case 'BankCard':
      return /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
        name: "cardholder",
        label: "\u0414\u0435\u0440\u0436\u0430\u0442\u0435\u043B\u044C \u043A\u0430\u0440\u0442\u044B",
        disabled: disabled
      });

    default:
      return null;
  }
}

var _default = PayoutMethodsFactory;
exports["default"] = _default;